<template>
  <v-container fluid>
  <v-card style="background-color: #F7F7F7" elevation="7">
    <v-row clas="bm-0 mb-0 pb-0">
      <v-col cols="12">
        <v-card-subtitle class="ml-2">
          <h2 class="text-uppercase indigo--text">
            {{ currentUser.ponencia.magistrado }}
          </h2>
          <h4 class="text-uppercase" style="color: #616161">
            {{roleUser}}
            <span v-if="currentUser.presidente == 1"> presidente</span>
          </h4>
          <v-btn
            small
            class="white--text"
            style="float: right; margin-top: -39px;"
            color="#1D2E4B"
            @click="$router.push({ name:'Tocas' })"
          >
            Panel de Tocas
          </v-btn>
          <v-divider class="mt-3"/>
        </v-card-subtitle>
      </v-col>
      <v-col cols="12" clas="mt-0">
        <v-card class="mx-4" color="#CED7DB">
          <v-toolbar color="#1D2E4B" dark dense>
            <v-toolbar-title class="text-uppercase">Turno de Tocas</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="mx-2">
      <v-spacer></v-spacer>
      <v-col cols="4" md="6" class="pt-0" v-if="roleUser == 'superadmin' ">
        <v-autocomplete
          :items = "listSalas"
          label="Seleccione una Sala"
          item-text="nombre"
          item-value="id"
          persistent-hint
          v-model="sala_id"
          required
          :rules="[v => !!v || 'Campo requerido']"
          key="id"
          :loading="loading"
          @change="clearSearch()"
        />
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="7" md="6" class="pt-0" v-if="sala_id">
        <v-text-field
          placeholder="Buscar Toca"
          v-model="buscar"
          hint="Ej. 1/2023"
          :loading="loading"
          clearable
          clear-icon="mdi-close-circle"
          @click:clear="clearSearch"
          v-on:keyup.enter="searchToca"
        >
          <v-btn slot="prepend" outlined fab x-small color="#607D8B" @click='searchToca()'>
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-text-field>
      </v-col>
    </v-row>

    <v-row class="mx-2 mt-0" v-if="sala_id">
      <v-col cols="12">
        <v-data-table
          :headers="headers_apelaciones"
          :items="getAllApelaciones"
          item-key="id"
          class="elevation-1"
          :loading="loading"
          loading-text="Buscando... Espere un momento"
          no-data-text="No hay Tocas por mostrar"
          :page="current"
          :items-per-page="itemsPerPage"
          hide-default-footer
          @page-count="pageCount = $event"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title class="d-none d-sm-flex">TOCAS</v-toolbar-title>
              <v-divider class="mx-4 pl-6 d-none d-sm-flex" inset vertical></v-divider>
              <!-- <v-select
                class="mt-7"
                :items="items_status"
                item-text="text"
                item-value="value"
                return-object
                label="Status"
                v-model="status"
                @change="numero='', anio='', buscar='', getApelaciones()"
              ></v-select> -->
            </v-toolbar>
          </template>
          <template v-slot:item.numero_completo="{ item }">
            <div>
              {{ item.toca.numero }}/{{ item.toca.anio }}
            </div>
            <!-- <div v-if="item.toca.ponencia_data && items_status.value == 20">
              <v-chip
                small
                color="red"
                text-color="white"
              >
                {{ item.toca.ponencia_data.magistrado }}
              </v-chip>
            </div> -->
          </template>
          <template v-slot:item.ponencia="{ item }">
            <span v-if="item.toca.ponencia_data">
             {{ item.toca.ponencia_data.magistrado }}
            </span>
            <span>
              <v-icon
                class="mr-2"
                color="grey"
              >
                mdi-minus
              </v-icon>
            </span>
          </template>
          <template v-slot:item.recepcion="{ item }">
            {{ item.fecha_recepcion | formatDate }}
          </template>
          <template v-slot:item.citacion="{ item }">
            {{ item.fecha_citacion | formatDate }}
          </template>
          <template v-slot:item.turno="{ item }">
            {{ item.fecha_turno | formatDate }}
          </template>
          <template v-slot:item.status="{ item }">
            <span v-if="item.status == 20">
              PARA TURNAR A PONENCIA
            </span>
            <span v-if="item.status == 30">
              PARA TURNAR RELATOR
            </span>
            <span v-if="item.status == 40">
              ASIGNADA A RELATOR
            </span>
            <span v-if="item.status == 41">
              PARA CUENTA
            </span>
            <span v-if="item.status == 42">
              PARA SESIONAR
            </span>
            <span v-if="item.status == 43">
              EN CUENTA COLEGIADA
            </span>
            <span v-if="item.status == 44">
              PENDIENTES DE FIRMA
            </span>
            <span v-if="item.status == 45">
              CONCLUIDA
            </span>
            <span v-if="item.status == 50">
              CANCELADA
            </span>
            <span v-if="item.status == 60">
              SIN MATERIA
            </span>
            <span v-if="item.status == 1">
              PARA AMPARO
            </span>
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn
              color="#1D2E4B"
              text
              outlined
              small
              @click="dialogDetalles=!dialogDetalles, item_dialog=item">
              VER
            </v-btn>
            <v-btn
              class="ml-2"
              v-if="item.status==20 || item.status==30"
              color="#1D2E4B"
              text
              outlined
              small
              @click="dialogAsignacion=!dialogAsignacion, item_dialog=item"
            >
              <span v-if="item.status==20">ASIGNAR PONENCIA</span>
              <span v-if="item.status==30">ASIGNAR RELATOR</span>
            </v-btn>
          </template>
        </v-data-table>
        <div v-if="total>=2" class="text-center pt-2 pb-1">
          <v-pagination
            class="mt-3"
            v-model="current"
            :length="total"
            @input="getApelaciones"
            :total-visible='7'
          >
          </v-pagination>
        </div>
      </v-col>
    </v-row>

    <!-- Dialog componente Detalles Apelacion -->
    <v-dialog
      v-model="dialogDetalles"
      fullscreen
      hide-overlay
      transition="fade-transition"
    ><DetallesCuenta
        v-if="dialogDetalles"
        :apelacion="item_dialog"
        :role="currentUser.roles[0].name"
        @reloadTocas="getApelaciones()"
        @closeModal="dialogDetalles=false"
      ></DetallesCuenta>
    </v-dialog>
    <!-- Fin Dialog componente Detalles Apelacion -->

    <!-- Dialog Asignar relator-magistrado -->
    <v-dialog
      v-model="dialogAsignacion"
      persistent
      max-width="600px"
    >
      <Asignar
        v-if="dialogAsignacion"
        :item="item_dialog"
        :status="item_dialog.status"
        :ponencias="getAllPonencias"
        :relatores="listRelatoresPonencia"
        @reloadTocas="getApelaciones()"
        @closeModal="dialogAsignacion=false"
      ></Asignar>
    </v-dialog>
  </v-card>
  </v-container>
</template>

<script>
  import DetallesCuenta from "../../components/DetallesCuenta";
  import Asignar from "../../components/Asignar";

  import { mapMutations } from "vuex";
  import { mapGetters } from "vuex";

  export default {
    components: {
      DetallesCuenta, Asignar
    },
    props: {
      source: String
    },
    data() {
      return {
        pageCount: 0,
        current:1,
        itemsPerPage: 20,
        total:0,
        status: {},
        loading: true,
        item_dialog:{},
        buscar: '',
        sala_id: '',
        ponencia_id: '',
        dialogDetalles: false,
        dialogAsignacion: false,
        anio:'',
        numero:'',
        getAllApelaciones: [],
        menu_excusa: [
          { name: "Registrar", icon: "mdi-plus" },
          { name: "Mostrar Todo", icon: "mdi-account-multiple-plus" }
        ],
        headers_apelaciones: [],
        items_status: []
      };
    },
    computed: {
      ...mapGetters(["listSalas", "roleUser", "currentUser", "getAllPonencias", "listRelatoresPonencia"])
    },
    created() {
      if (this.currentUser.presidente == 1) {
        this.items_status = [
          // { text: "PARA TURNAR MAGISTRADO", value: 20, align: "", sortable: true, width: '' },
          { text: "PARA TURNAR RELATOR", value: 30, align: "", sortable: true, width: '' },
        ]
        this.status = {
          text: "PARA TURNAR RELATOR",
          value: 30,
          align: "",
          sortable: true
        }
      } else {
        this.items_status = [
          { text: "PARA TURNAR RELATOR", value: 30, align: "", sortable: true, width: '' },
        ]
        this.status = {
          text: "PARA TURNAR RELATOR",
          value: 30,
          align: "",
          sortable: true
        }
      }
      if (this.roleUser == 'superadmin') {
        this.loading = false
        return false;
      } else {
        let user = JSON.parse(localStorage.getItem('user'));
        this.sala_id = user.sala_id
        this.ponencia_id = user.ponencia_id
      }
      this.getApelaciones();
      this.$store.dispatch("GET_SALAS", { url: "salas" });
      this.$store.dispatch("GET_RELATORES_PONENCIA", { url: "relatores", params: {ponencia_id:this.ponencia_id} });
    },
    methods: {
      getApelaciones(){
        this.$store.dispatch("GET_PONENCIAS", { url: "ponencias" });
        this.loading = true
        this.getAllApelaciones = []
        this.headers_apelaciones = []
        // if (this.status) {
          this.$store.dispatch("GET_APELACIONES", {
            url: "/apelaciones",
            params: {
              page:this.current,
              status:  this.status.value,
              sala_id:  this.sala_id,
              anio:  this.anio || undefined,
              numero:  this.numero || undefined
            }
          }).then(response => {
            this.loading = false
            this.current = response.data.data.apelaciones.current_page;
            this.total = response.data.data.apelaciones.last_page;
            this.getAllApelaciones = response.data.data.apelaciones.data;
            if (this.buscar != '' && this.buscar != null) {
              this.headers_apelaciones = [
                { text: "Estatus", value: "status", align: "", sortable: true, width: '' },
                // { text: "Ponencia", value: "ponencia", align: "center", sortable: true, width: '' },
                { text: "Toca", value: "numero_completo", align: "center", sortable: true, width: '' },
                { text: "Expediente", value: "toca.expediente", align: "", sortable: true, width: '' },
                { text: "Tipo Apelacion", value: "tipo_apelacion.nombre", align: "", sortable: true, width: '' },
                { text: "F.Recepción", value: "recepcion", align: "", sortable: true, width: '' },
                // { text: "F.Citación", value: "citacion", align: "", sortable: true, width: '' },
                { text: "F.Turno", value: "turno", align: "", sortable: true, width: '' },
                { text: "", value: "action", align: "center", sortable: false, width: '' },
              ]
            }
            else if (this.status.text=="TURNADAS") {
              this.headers_apelaciones = [
                { text: "Estatus", value: "status", align: "", sortable: true, width: '' },
                { text: "Toca", value: "numero_completo", align: "center", sortable: true, width: '' },
                { text: "Expediente", value: "toca.expediente", align: "", sortable: true, width: '' },
                { text: "Tipo Apelacion", value: "tipo_apelacion.nombre", align: "", sortable: true, width: '' },
                { text: "F.Recepción", value: "recepcion", align: "", sortable: true, width: '' },
                // { text: "F.Citación", value: "citacion", align: "", sortable: true, width: '' },
                { text: "F.Turno", value: "turno", align: "", sortable: true, width: '' },
                { text: "", value: "action", align: "center", sortable: false, width: '' },
              ]
            }
            else {
              this.headers_apelaciones = [
                { text: "Toca", value: "numero_completo", align: "center", sortable: true, width: '' },
                { text: "Expediente", value: "toca.expediente", align: "", sortable: true, width: '' },
                { text: "Tipo Apelacion", value: "tipo_apelacion.nombre", align: "", sortable: true, width: '' },
                { text: "F.Recepción", value: "recepcion", align: "", sortable: true, width: '' },
                // { text: "F.Citación", value: "citacion", align: "", sortable: true, width: '' },
                { text: "F.Turno", value: "turno", align: "", sortable: true, width: '' },
                { text: "", value: "action", align: "center", sortable: false, width: '' },
              ]
            }
          });
        // }
      },
      searchToca(){
        if (!this.buscar) return false;
        if (this.buscar.length >= 5 ) {
          this.status = { text: "", value: "" };
          if ( this.buscar.includes("/") ) var tocacompleto = this.buscar.replace('/','');
          else var tocacompleto = this.buscar;
          this.anio = tocacompleto.substr(tocacompleto.length - 4);
          this.numero = tocacompleto.slice(0, tocacompleto.length - 4);
          this.getApelaciones()
        }
      },
      clearSearch () {
        this.numero = ''
        this.anio = ''
        this.status = { text: "PARA TURNAR MAGISTRADO", value: 20, align: "", sortable: true, width: '' },
        this.getApelaciones()
      }
    }
  };
</script>
